export enum FeatureFlags {
  COMPARE_VIEW = "designControlsComparisonView",
  RELATED_RECORDS_TAB = "relatedRecordsTab",
  LINK_RESOURCE_LIBRARY_PRODUCT = "dc-link-resource-library-product",
  MAJOR_MINOR_VERSION = "design-element-major-minor-version-ui",
}
